import $api from "@/zapi-frontend/shared/api/axios";

export async function postLogout() {
  return $api.post("/auth/logout");
}
